/* Bulk-action sticky toolbar shown when admins select rows in Manage Users. */
import { Trash2 } from "lucide-react";

export default function BulkUsersToolbar({
  selectedCount,
  bulkBusy,
  onReactivate, onDeactivate,
  onSetRole, onSetProgram,
  onDelete, onClear,
}) {
  return (
    <div
      className="sticky top-2 z-10 mb-4 rounded-lg border border-[#C9A961]/40 bg-[#1a1814]/95 backdrop-blur px-3 py-2 flex flex-wrap items-center gap-2 shadow-lg"
      data-testid="bulk-toolbar"
    >
      <span className="text-xs text-[#C9A961] mr-2" data-testid="bulk-selected-count">
        {selectedCount} selected
      </span>
      <BulkBtn onClick={onReactivate} disabled={bulkBusy} testid="bulk-reactivate">
        Reactivate
      </BulkBtn>
      <BulkBtn onClick={onDeactivate} disabled={bulkBusy} testid="bulk-deactivate">
        Deactivate
      </BulkBtn>
      <BulkSelect
        disabled={bulkBusy}
        testid="bulk-role-select"
        placeholder="Set role…"
        options={[
          { value: "participant", label: "participant" },
          { value: "facilitator", label: "facilitator" },
          { value: "admin", label: "admin" },
        ]}
        onPick={onSetRole}
      />
      <BulkSelect
        disabled={bulkBusy}
        testid="bulk-program-select"
        placeholder="Move to program…"
        options={[
          { value: "men", label: "men's" },
          { value: "women", label: "women's" },
        ]}
        onPick={onSetProgram}
      />
      <button
        disabled={bulkBusy}
        onClick={onDelete}
        className="text-xs px-2 py-1 rounded border border-red-500/30 text-red-400 hover:bg-red-500/10 disabled:opacity-50 flex items-center gap-1"
        data-testid="bulk-delete"
      >
        <Trash2 className="w-3 h-3" /> Delete
      </button>
      <button
        disabled={bulkBusy}
        onClick={onClear}
        className="text-xs px-2 py-1 rounded text-[#8A8782] hover:text-[#C9A961] ml-auto"
        data-testid="bulk-clear"
      >
        {bulkBusy ? "Working…" : "Clear"}
      </button>
    </div>
  );
}

function BulkBtn({ children, onClick, disabled, testid }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className="text-xs px-2 py-1 rounded border border-[#C9A961]/30 text-[#D1CFC9] hover:text-[#C9A961] hover:border-[#C9A961]/65 disabled:opacity-50"
      data-testid={testid}
    >
      {children}
    </button>
  );
}

function BulkSelect({ disabled, testid, placeholder, options, onPick }) {
  return (
    <select
      disabled={disabled}
      defaultValue=""
      onChange={(e) => {
        const v = e.target.value;
        e.target.value = "";
        if (v) onPick(v);
      }}
      className="input-tcpi py-1 px-2 text-xs bg-transparent text-[#D1CFC9]"
      data-testid={testid}
    >
      <option value="" disabled>{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
